import { FinancialApplicationSection } from "./enums";

export const APPLICATION_NAVIGATION_ITEMS: Partial<
  Record<FinancialApplicationSection, { label: string; section: FinancialApplicationSection }>
> = {
  [FinancialApplicationSection.ProductSelection]: {
    label: "Product Details",
    section: FinancialApplicationSection.ProductSelection,
  },
  [FinancialApplicationSection.PersonInformationBasicInfo]: {
    label: "Client Details",
    section: FinancialApplicationSection.PersonInformationBasicInfo,
  },
  [FinancialApplicationSection.AccountDetails]: {
    label: "Account Details",
    section: FinancialApplicationSection.AccountDetails,
  },
  [FinancialApplicationSection.JointAccountOwners]: {
    label: "Joint Owners",
    section: FinancialApplicationSection.JointAccountOwners,
  },
  [FinancialApplicationSection.PersonalAccountBeneficiaries]: {
    label: "Beneficiaries",
    section: FinancialApplicationSection.PersonalAccountBeneficiaries,
  },
  [FinancialApplicationSection.OrganizationInformation]: {
    label: "Entity Info",
    section: FinancialApplicationSection.OrganizationInformation,
  },
  [FinancialApplicationSection.KeyPeople]: {
    label: "Key People",
    section: FinancialApplicationSection.KeyPeople,
  },
  [FinancialApplicationSection.PersonalAccountAcceptableUse]: {
    label: "Personal Acceptable Use",
    section: FinancialApplicationSection.PersonalAccountAcceptableUse,
  },
  [FinancialApplicationSection.OrganizationAccountAcceptableUse]: {
    label: "Entity Acceptable Use",
    section: FinancialApplicationSection.OrganizationAccountAcceptableUse,
  },
  [FinancialApplicationSection.OptIns]: {
    label: "Account Features & Preferences",
    section: FinancialApplicationSection.OptIns,
  },
  [FinancialApplicationSection.FinancialApplicationDocuments]: {
    label: "Application Documents",
    section: FinancialApplicationSection.FinancialApplicationDocuments,
  },
  [FinancialApplicationSection.PersonalAccountRiskReview]: {
    label: "Personal Account Risk Review",
    section: FinancialApplicationSection.PersonalAccountRiskReview,
  },
  [FinancialApplicationSection.LawFirmOrganizationAccountRiskReview]: {
    label: "Law Firm Risk Review",
    section: FinancialApplicationSection.LawFirmOrganizationAccountRiskReview,
  },
  [FinancialApplicationSection.NonLawFirmOrganizationAccountRiskReview]: {
    label: "Non-Law Firm Risk Review",
    section: FinancialApplicationSection.NonLawFirmOrganizationAccountRiskReview,
  },
};
